import { render, staticRenderFns } from "./AiForge.vue?vue&type=template&id=42268f52&"
import script from "./AiForge.vue?vue&type=script&lang=js&"
export * from "./AiForge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports